import './../../index.css';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import hoc from '../../hoc.js';
import 'classnames';
import '@hh.ru/magritte-common-use-disabled';
import '@hh.ru/magritte-ui-badge';
import '../../IconDynamic-D_LIh_94.js';
import '../../Skeleton.js';
import '@hh.ru/magritte-ui-skeleton';

const PenOutlinedSize24Component = (props, ref) => (jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("g", { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.8 21.2L2.8 17.6746L14.1009 6.37362L17.6264 9.89905L6.32544 21.2H2.8ZM18.8992 8.62626L20.4699 7.05558C21.4434 6.08206 21.4434 4.50366 20.4699 3.53014C19.4963 2.55662 17.9179 2.55662 16.9444 3.53014L15.3737 5.10083L18.8992 8.62626ZM1 23L1 16.929L15.6716 2.25735C17.3481 0.580884 20.0662 0.580883 21.7427 2.25735C23.4191 3.93382 23.4191 6.6519 21.7427 8.32837L7.07102 23H1Z", fill: "var(--magritte-ui-icon-color)" }) }) }));
const PenOutlinedSize24 = hoc(forwardRef(PenOutlinedSize24Component), 'PenOutlinedSize24');

export { PenOutlinedSize24 as default };
//# sourceMappingURL=PenOutlinedSize24.js.map
